<template>
  <defaultLayout :data="data" :page="page" :section="section">
    <template slot-scope="slotProps">
      <component
        v-for="block in data.blocks"
        :is="`module_${block.module}`"
        :key="block.title" :data="block"
        :window="slotProps.window"
        :scrollState="slotProps.monitorState"
        :scrollPosition="slotProps.scrollPosition"
      />
    </template>
  </defaultLayout>
</template>

<script>
import defaultLayout from '@/layouts/default';

export default {
  name: 'modulesLayout',
  props: ['data', 'page'],
  components: { defaultLayout },
  data() {
    return {
      section: 'default',
    };
  },
};
</script>

<style lang="scss">
@import '../styles/main.scss';
@import '../styles/_typography.scss';
@import '../styles/_mixins.scss';

.section-default {
  main,
  footer {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr $layout--content-gutter-width $layout--max-content-container-width $layout--content-gutter-width 1fr;

    & > [data-module] {
      grid-column: 3 / span 1;

      &.stretch {
        grid-column: 2 / span 3;
      }

      &.constrain {
        margin: 0 ($layout--gutter * 2);
      }
    }

    @include mq($layout--max-width, down) {
      grid-template-columns: 0 1fr $layout--max-content-container-width 1fr 0;
    }

    @include mq($layout--max-content-container-width, down) {
      grid-template-columns: 0 0 100% 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/modules.vue